module.exports = __webpack_public_path__ + "img/namer_yes.9459d48a.png";